import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const previewContentAtom = atomWithStorage("previewContent", false, createJSONStorage(), { getOnInit: true });
export const contentfulKeyAtom = atom((get) => {
	let key = process.env.REACT_APP_CONTENTFUL_KEY;
	const isPreview = get(previewContentAtom) === true;
	if (isPreview) key = process.env.REACT_APP_CONTENTFUL_KEY_PREVIEW;

	return key;
});
